import { useEffect, useRef } from "react"

const NestPayDataHandler = ({data}) => {
    const formRef = useRef(null)
    const clientIdRef = useRef(null)
    const cardNumberRef = useRef(null)
    const cardExpDateYearRef = useRef(null)
    const cardExpDateMonthRef = useRef(null)
    const cardTypeRef = useRef(null)
    const cvcRef = useRef(null)
    const amountRef = useRef(null)
    const oidRef = useRef(null)
    const okUrlRef = useRef(null)
    const failUrlRef = useRef(null)
    const rndRef = useRef(null)
    const currencyRef = useRef(null)
    const storeTypeRef = useRef(null)
    const langRef = useRef(null)
    const hashRef = useRef(null)

    useEffect(() => {
        if(!data) return

        console.log("heere")

        clientIdRef.current.value = data.clientid
        cardNumberRef.current.value = data.number
        cardExpDateMonthRef.current.value = data.expM
        cardExpDateYearRef.current.value = data.expY
        cvcRef.current.value = data.cvc
        cardTypeRef.current.value = "1"
        amountRef.current.value = data.amount
        oidRef.current.value = data.oid
        okUrlRef.current.value = data.okUrl
        failUrlRef.current.value = data.failUrl
        rndRef.current.value = data.rnd
        currencyRef.current.value = data.currency
        storeTypeRef.current.value = "3d"
        langRef.current.value = "tr"
        hashRef.current.value = data.hash

        formRef.current.submit()
    }, [data])
    
    return (
    <form className='hidden' ref={formRef} action="https://istest.asseco-see.com.tr/fim/est3Dgate" method="POST" >
          <input ref={clientIdRef} type="hidden" name="clientid" value="" />
          <input ref={cardNumberRef} type="hidden" name="pan" value="" />
          <input ref={cardExpDateMonthRef} type="hidden" name="Ecom_Payment_Card_ExpDate_Month" value="" />
          <input ref={cardExpDateYearRef} type="hidden" name="Ecom_Payment_Card_ExpDate_Year" value="" />
          <input ref={cardTypeRef} type="hidden" name="cardType" value="" />
          <input ref={cvcRef} type="hidden" name="cv2" value="" />
          <input ref={amountRef} type="hidden" name="amount" value="" />
          <input ref={oidRef} type="hidden" name="oid" value="" />
          <input ref={okUrlRef} type="hidden" name="okUrl" value="" />
          <input ref={failUrlRef} type="hidden" name="failUrl" value="" />
          <input ref={rndRef} type="hidden" name="rnd" value="" />
          <input ref={currencyRef} type="hidden" name="currency" value="" />
          <input ref={storeTypeRef} type="hidden" name="storetype" value="" />
          <input ref={langRef} type="hidden" name="lang" value="" />
          <input ref={hashRef} type="hidden" name="hash" value="" />
    </form>
    )
}

export default NestPayDataHandler